import { AxiosRequestConfig, AxiosResponse } from "axios";
import api from "./api";
import api_login from "./api_login";
import api_fatura from "./api_fatura";

// /** Link dos logotipos */


export async function get_pdf(token: string, rota: string, config?: AxiosRequestConfig) {

  const resulte: AxiosResponse = await api.get(rota + "", {
    headers: { "Content-Type": "application/json", Authorization:`Bearer ${token}` },
    responseType: 'blob',
    ...config
  });

  // console.log(resulte.status.toString());

  return resulte;
}
/** Axios Post  */
export async function post(token: string, rota: string, dados: any) {

  const resulte: AxiosResponse = await api.post(rota, dados, {
    headers: { "Content-Type": "application/json", Authorization: `Bearer ${token}` },
  });

  // console.log(resulte.status.toString());

  return resulte;
}
export async function put(token: string, rota: string, dados: any) {

  const resulte: AxiosResponse = await api.put(rota, dados, {
    headers: { "Content-Type": "application/json", Authorization: `Bearer ${token}` },
  });

  // console.log(resulte.status.toString());

  return resulte;
}
export async function post_login(token: string, rota: string, dados: any) {

  const resulte: AxiosResponse = await api_login.post(rota, dados, {
    headers: { "Content-Type": "application/json", Authorization: `Bearer ${token}` },
  });

  // console.log(resulte.status.toString());

  return resulte;
}


export async function post_imagem(token: string, rota: string, dados: any) {
  const resulte: AxiosResponse = await api_login.post(rota, dados, {
    headers: { "Content-Type": "multipart/form-data", Authorization: `Bearer ${token}` },
  });

  // console.log(resulte.status.toString());

  return resulte;
}

export async function post_file(token: string, rota: string, dados: any) {
  const resulte: AxiosResponse = await api.post(rota, dados, {
    headers: { "Content-Type": "multipart/form-data", Authorization: `Bearer ${token}` },
  });

  // console.log(resulte.status.toString());

  return resulte;
}

export async function post_file_faturas(token: string, rota: string, dados: any) {
  const resulte: AxiosResponse = await api_fatura.post(rota, dados, {
    headers: { "Content-Type": "multipart/form-data", Authorization: `Bearer ${token}` },
  });
  // Authorization: `Bearer ${token}` 
  // console.log(resulte.status.toString());
  // console.log("post_file_faturas",resulte);

  return resulte;
}


/** Axios Get */
export async function get(token: string, rota: string) {

  const resulte: AxiosResponse = await api.get(rota + "", {
    headers: { "Content-Type": "application/json", Authorization: `Bearer ${token}` },
  });

  // console.log(resulte.status.toString());

  return resulte;
}
export async function get_login(token: string, rota: string) {

  const resulte: AxiosResponse = await api_login.get(rota + "", {
    headers: { "Content-Type": "application/json", Authorization: `Bearer ${token}` },
  });

  // console.log(resulte.status.toString());

  return resulte;
}


/** Axios Delete */
export async function del(token: string, id: string) {

  const resulte: AxiosResponse = await api.delete(id, {
    headers: { "Content-Type": "application/json", Authorization: `Bearer ${token}` },
  });

  // console.log(resulte.status.toString());

  return resulte;
}
export async function del_login(token: string, id: string) {

  const resulte: AxiosResponse = await api_login.delete(id, {
    headers: { "Content-Type": "application/json", Authorization: `Bearer ${token}` },
  });

  // console.log(resulte.status.toString());

  return resulte;
}


export async function del_using_obj(token: string, rota: string, dados: any) {

  const resulte: AxiosResponse = await api.delete(rota, {
    headers: { "Content-Type": "application/json", Authorization: `Bearer ${token}` }, data: dados
  },);

  // console.log(resulte.status.toString());

  return resulte;
}


